import React from 'react';
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import { ja } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import './JapaneseDatePicker.css';

// Register Japanese locale
registerLocale('ja', ja);

interface JapaneseDatePickerProps {
  selected: Date | null;
  onChange: (date: Date | null) => void;
  placeholder?: string;
  minDate?: Date | null;
  maxDate?: Date | null;
  className?: string;
  disabled?: boolean;
}

const JapaneseDatePicker: React.FC<JapaneseDatePickerProps> = ({
  selected,
  onChange,
  placeholder = "yyyy/mm/dd",
  minDate = null,
  maxDate = null,
  className = "",
  disabled = false
}) => {
  return (
    <DatePicker
      selected={selected}
      onChange={onChange}
      dateFormat="yyyy/MM/dd"
      locale="ja"
      placeholderText={placeholder}
      minDate={minDate || undefined}
      maxDate={maxDate || undefined}
      className={`japanese-date-picker ${className}`}
      disabled={disabled}
      showYearDropdown
      showMonthDropdown
      dropdownMode="select"
      yearDropdownItemNumber={15}
      scrollableYearDropdown
      isClearable
      autoComplete="off"
    />
  );
};

export default JapaneseDatePicker;
